import api from '../../../../api/client'

export async function listBranches(params) {
  const { data } = await api.get('/branches/', { params })
  return data
}

export async function getBranchDetail(branchId) {
  const { data } = await api.get(`/branches/${branchId}`)
  return data
}

export async function createBranch(payload) {
  const { data } = await api.post('/branches/', payload)
  return data
}

export async function updateBranch(branchId, payload) {
  const { data } = await api.put(`/branches/${branchId}`, payload)
  return data
}

export async function archiveBranch(branchId) {
  const { data } = await api.post(`/branches/${branchId}/archive`)
  return data
}

export async function listCompanyOptions(params) {
  const { data } = await api.get('/options/companies', { params })
  return Array.isArray(data) ? data : []
}
